import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatBubbleSlashRegular from './chat-bubble-slash-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ChatBubbleSlashRegular {...props} />;
}
SvgComponent.iconName = 'chatBubbleSlashRegular';

export const ChatBubbleSlashRegularIcon = svgIconWrapper(SvgComponent);
